import { useTranslation } from 'react-i18next';
import CasFormDropdown from '@cas/components/inputs/cas-form-dropdown/CasFormDropdown';
import CasFormCheckbox from '@cas/components/inputs/cas-form-checkbox/CasFormCheckbox';
import { GeofenceFormModel } from '@casops/store/apis/geofencesApi';
import useSpeedOptions from './useSpeedOptions';
import useHoldTimeOptions from './useHoldTimeOptions';
import useInterventionControlOptions from './useInterventionControlOptions';
import styles from './RulesControls.module.scss';
import { UseGeofenceFormTabsProps } from '../form/useGeofenceFormTabs';

type FormModel = GeofenceFormModel;

export function RulesControls({ control, isReadonly }: UseGeofenceFormTabsProps<FormModel>) {
  const { t } = useTranslation();

  const speedOptions = useSpeedOptions();
  const lessThanHoldTimeOptions = useHoldTimeOptions(false);
  const greaterThanHoldTimeOptions = useHoldTimeOptions(true);
  const interventionControlOptions = useInterventionControlOptions();

  return (
    <>
      <div className={styles.sectionTitle}>{t('ReportEvent')}</div>
      <div className={styles.checkboxGroup}>
        <CasFormCheckbox
          control={control}
          name="rules.createEventOnEntry"
          label={t('Fields.EventOnEntry')}
          isReadonly={isReadonly}
        />
        <CasFormCheckbox
          control={control}
          name="rules.createEventOnExit"
          label={t('Fields.EventOnExit')}
          isReadonly={isReadonly}
        />
        <CasFormCheckbox
          control={control}
          name="rules.createEventIfAtAndDidNotStop"
          label={t('Fields.EventOnDidNotStop')}
          isReadonly={isReadonly}
        />
      </div>

      <CasFormDropdown
        control={control}
        name="rules.createEventIfAtAndSpeeding"
        label={t('Fields.EventOnSpeeding')}
        items={speedOptions}
        isReadonly={isReadonly}
      />
      <CasFormDropdown
        control={control}
        name="rules.speedLimitLoaded"
        label={t('Fields.EventOnSpeedingLoaded')}
        items={speedOptions}
        isReadonly={isReadonly}
      />
      <CasFormDropdown
        control={control}
        name="rules.createEventIfAtForLessThanSeconds"
        label={t('Fields.EventIfAtForLessThanSeconds')}
        items={lessThanHoldTimeOptions}
        isReadonly={isReadonly}
      />
      <CasFormDropdown
        control={control}
        name="rules.createEventIfAtForLongerThanSeconds"
        label={t('Fields.EventIfAtForLongerThanSeconds')}
        items={greaterThanHoldTimeOptions}
        isReadonly={isReadonly}
      />

      <div className={styles.sectionTitle}>{t('AlarmLogic')}</div>
      <div className={styles.checkboxGroup}>
        <CasFormCheckbox
          control={control}
          name="rules.alarmLogicMuteAll"
          label={t('Fields.AlarmLogicMuteAll')}
          isReadonly={isReadonly}
        />
        <CasFormCheckbox
          control={control}
          name="rules.alarmLogicRunAreaLogic"
          label={t('Fields.RunAreaLogic')}
          isReadonly={isReadonly}
        />
      </div>

      <div className={styles.sectionTitle}>{t('LevelNumber', { level: 9 })}</div>
      <CasFormDropdown
        control={control}
        name="rules.interventionEnabled"
        label={t('Fields.InterventionControls')}
        items={interventionControlOptions}
        isReadonly={isReadonly}
      />
    </>
  );
}

export default RulesControls;
